@if (patient) {
  <app-traitement-data-mode [patient]="patient!" />
  @if (patient.tableauDeBord?.mode?.value == "PPC FIXE") {
    <app-traitement-data-pression-fixe [patient]="patient!" />
  } @else {
    <app-traitement-data-pression-auto [patient]="patient!" />
  }
  <app-traitement-data-type-de-masque [patient]="patient!" />
  <app-traitement-data-obs [patient]="patient!" />
  <app-traitement-data-iahr [patient]="patient!" />
  <app-traitement-data-fuites [patient]="patient!" />
  <app-traitement-data-p90-95 [patient]="patient!" />
  @if (activite == "O2PPC") {
    <app-traitement-data-o2-repos [patient]="patient!" />
    <app-traitement-data-o2-effort [patient]="patient!" />
    <app-traitement-data-duree [patient]="patient!" />
  }
} @else {
  <app-traitement-data></app-traitement-data>
  <app-traitement-data></app-traitement-data>
  <app-traitement-data></app-traitement-data>
  <app-traitement-data></app-traitement-data>
  <app-traitement-data></app-traitement-data>
  <app-traitement-data></app-traitement-data>
  <app-traitement-data></app-traitement-data>
  <app-traitement-data></app-traitement-data>
}
